import { Store } from "../Store.dt";
import { SET_COMMON_DATA } from "./CommonTypes";

export const commonInitial:any = {
    agentCount:null
}
export function CommonReducer(state=commonInitial, action:Store){
    switch(action.type){
        case SET_COMMON_DATA:
            return {...action.payload}
        default:
            return state
    }
}